import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleNumberClick = (num) => {
    if (pin.length < 4 && !isLoading) {
      const newPin = pin + num;
      setPin(newPin);
      setError(false);
      
      if (newPin.length === 4) {
        // Pequeno delay para mostrar o 4º dígito antes de fazer login
        setTimeout(() => {
          handleLogin(newPin);
        }, 200);
      }
    }
  };

  const handleBackspace = () => {
    if (!isLoading) {
      setPin(pin.slice(0, -1));
      setError(false);
    }
  };

  const handleLogin = async (pinToSubmit) => {
    setIsLoading(true);
    try {
      await login(pinToSubmit);
      navigate('/pos');
    } catch (error) {
      setError(true);
      setPin('');
      // Shake animation feedback
      setTimeout(() => setError(false), 500);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1761062083136-dcfbd2a000f9?auto=format&fit=crop&w=1920&q=80"
          alt="background"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-[#09090b]"></div>
      
      <div className="relative max-w-md w-full mx-auto p-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold font-oswald text-white mb-2">BÉNI RESTAURANT</h1>
          <p className="text-white/60 font-inter">Digite seu PIN para acessar</p>
        </div>

        <div className={`flex justify-center gap-4 mb-8 ${error ? 'animate-shake' : ''}`}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              data-testid={`pin-dot-${i}`}
              className={`w-4 h-4 rounded-full transition-all duration-300 ${
                pin.length > i 
                  ? error ? 'bg-red-500 scale-125' : 'bg-[#FF5500] scale-125' 
                  : 'bg-white/20'
              }`}
            />
          ))}
        </div>

        {error && (
          <p className="text-red-500 text-center mb-4 font-inter text-sm animate-fade-in">
            PIN inválido. Tente novamente.
          </p>
        )}

        <div className="grid grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button
              key={num}
              data-testid={`pin-button-${num}`}
              onClick={() => handleNumberClick(num.toString())}
              disabled={isLoading}
              className="h-16 w-16 sm:h-20 sm:w-20 mx-auto rounded-full bg-[#18181b] hover:bg-[#27272a] text-xl sm:text-2xl font-oswald text-white transition-all active:scale-90 flex items-center justify-center border border-white/5 shadow-lg disabled:opacity-50"
            >
              {num}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-4 sm:gap-6">
          <div></div>
          <button
            data-testid="pin-button-0"
            onClick={() => handleNumberClick('0')}
            disabled={isLoading}
            className="h-16 w-16 sm:h-20 sm:w-20 mx-auto rounded-full bg-[#18181b] hover:bg-[#27272a] text-xl sm:text-2xl font-oswald text-white transition-all active:scale-90 flex items-center justify-center border border-white/5 shadow-lg disabled:opacity-50"
          >
            0
          </button>
          <button
            data-testid="pin-button-backspace"
            onClick={handleBackspace}
            disabled={isLoading}
            className="h-16 w-16 sm:h-20 sm:w-20 mx-auto rounded-full bg-[#18181b] hover:bg-[#27272a] text-lg sm:text-xl font-oswald text-white transition-all active:scale-90 flex items-center justify-center border border-white/5 shadow-lg disabled:opacity-50"
          >
            ←
          </button>
        </div>

        {isLoading && (
          <div className="mt-8 flex justify-center">
            <div className="w-8 h-8 border-2 border-[#FF5500] border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-10px); }
          75% { transform: translateX(10px); }
        }
        .animate-shake {
          animation: shake 0.3s ease-in-out;
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Login;
